import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './styles.scss';

const PhoneNumberInput = (props) => {
  const {
    name,
    value,
    onChange,
    containerClass,
    placeholder,
    onBlur,
    style,
  } = props;

  return (
    <PhoneInput
      country={'us'}
      copyNumbersOnly={false}
      name={name}
      containerClass={containerClass}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      onBlur={onBlur}
      inputStyle={style}
    />
  );
};

export default PhoneNumberInput;
